import React from 'react';
import { Link } from 'react-router-dom';
import { linkBlue } from '../constants';

const style = {
  border: 0,
  boxShadow: 'none',
  padding: '4px 8px',
  color: linkBlue
};

const LinkButton = ({ to, href, children, target }) => {
  if (to) {
    return (
      <Link to={to} style={style}>
        {children}
      </Link>
    );
  } else {
    if (target) {
      return (
        <a href={href} style={style} target={target}>
          {children}
        </a>
      );
    } else {
      return (
        <a href={href} style={style}>
          {children}
        </a>
      );
    }
  }
};

export default LinkButton;
